import { render, staticRenderFns } from "./Patent-navigation.vue?vue&type=template&id=40daeed5&scoped=true&"
import script from "./Patent-navigation.vue?vue&type=script&lang=js&"
export * from "./Patent-navigation.vue?vue&type=script&lang=js&"
import style0 from "./Patent-navigation.vue?vue&type=style&index=0&id=40daeed5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40daeed5",
  null
  
)

export default component.exports